type DefaultHeaders = 'edit-session-uuid';

export default new Map<DefaultHeaders, string>();
